module.exports = __webpack_public_path__ + "static/media/banner-extra-img-left.09f1cbf0.png";